import script from "./liveItem.vue?vue&type=script&setup=true&name=liveItem&lang=js"
export * from "./liveItem.vue?vue&type=script&setup=true&name=liveItem&lang=js"

import "./liveItem.vue?vue&type=style&index=0&id=1119c82c&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1119c82c"]])

export default __exports__